import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Icon } from "@/lib/icons";
import { Button } from "@/components/kit";

export default function DriveHealthBanner() {
  const [h, setH] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/drive/health").then((r) => setH(r.data)).catch(() => {}), []);

  useEffect(() => {
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [load]);

  const reconnect = async () => {
    setBusy(true);
    try {
      const r = await api.post("/drive/health/check");
      if (r.data.ok) { setH(r.data); toast.success("Google Drive is working again"); return; }
      if (r.data.needs_reauth) {
        const c = await api.get("/drive/connect");
        window.location.href = c.data.authorization_url;
        return;
      }
      setH(r.data);
      toast.error("Drive still isn't responding. Try again in a few minutes.");
    } catch {
      toast.error("Couldn't reach Google Drive");
    } finally {
      setBusy(false);
    }
  };

  if (!h || h.ok) return null;
  return (
    <div data-testid="drive-health-banner" role="alert" className="mb-4 flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-maroon/40 bg-maroon/10 px-4 py-3">
      <Icon name="AlertTriangle" className="w-5 h-5 text-maroon shrink-0 hidden sm:block" />
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-ink text-[15px]" data-testid="drive-health-title">
          {h.connected ? "Google Drive connection failed" : "Google Drive isn't connected"}
        </div>
        <div className="text-[13px] text-ink/70">Board meeting documents, Garden Plot files, Event photos and Grant files can't upload or open until Drive is reconnected.</div>
      </div>
      <Button onClick={reconnect} disabled={busy} className="justify-center shrink-0" data-testid="drive-health-reconnect">
        {busy ? "Checking…" : "Reconnect"}
      </Button>
    </div>
  );
}
